<template>
    <v-dialog v-model="dialog" max-width="690" :persistent="[ 'success', 'loading' ].includes(addTransactionState)" @click:outside="outsideToCloseModal()">
        <v-card class="standard-row dialog-create-doc-card">
            <v-row no-gutters class="standard-row" style="padding: 29px 4% 5px 4%;">
                <v-col cols="12" sm="auto" md="auto" lg="auto" class="pr-sm-3 set-center-document-modal">
                    <svg width="35" class="mt-1" height="35" viewBox="0 0 28 31" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.35272 3.00781H2.88792C2.29585 3.00781 1.72803 3.22892 1.30937 3.62249C0.890717 4.01607 0.655518 4.54987 0.655518 5.10647V28.1917C0.655518 28.7482 0.890717 29.2821 1.30937 29.6756C1.72803 30.0692 2.29585 30.2903 2.88792 30.2903H25.2119C25.804 30.2903 26.3718 30.0692 26.7905 29.6756C27.2091 29.2821 27.4443 28.7482 27.4443 28.1917V5.10647C27.4443 4.54987 27.2091 4.01607 26.7905 3.62249C26.3718 3.22892 25.804 3.00781 25.2119 3.00781H20.7471"
                            stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M14.0499 11.4015V24.1109M20.7471 17.6974H7.35266M9.58506 0.908203H18.5147C19.1067 0.908203 19.6745 1.12931 20.0932 1.52288C20.5119 1.91646 20.7471 2.45026 20.7471 3.00686C20.7471 3.56345 20.5119 4.09725 20.0932 4.49083C19.6745 4.8844 19.1067 5.10551 18.5147 5.10551H9.58506C8.99299 5.10551 8.42517 4.8844 8.00652 4.49083C7.58786 4.09725 7.35266 3.56345 7.35266 3.00686C7.35266 2.45026 7.58786 1.91646 8.00652 1.52288C8.42517 1.12931 8.99299 0.908203 9.58506 0.908203V0.908203Z"
                            stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" lg="auto"
                    class="font-theme font-size-header-confirm-create set-center-document-modal">
                    {{ getTitle() }}
                </v-col>
            </v-row>
            <!-- <v-row class="standard-row" style="padding: 0 4%;">
                <v-card class="standard-row elevation-0 scroll-create-purchase-modal"
                    style="background-color: rgba(217, 217, 217, 0.44); border-radius: 0px; min-height: 263px;">
                    <div class="mr-3 justify-center" style="padding-top: 10px; font-size: 20px; text-align: center;">
                        <sweetalert-icon :icon="addTransactionState" />
                        <p class="font-theme">บันทึกสำเร็จ</p>
                        <p class="font-theme">{{ responseData.document_id }}</p>

                    </div>
                </v-card>
            </v-row> -->
            <v-row class="standard-row" style="padding: 0 4%;">
                <v-card class="standard-row elevation-0 scroll-create-purchase-modal" style="background-color: rgba(217, 217, 217, 0.44); border-radius: 0px; min-height: 263px;">
                    <template>
                        <v-row no-gutters class="standard-row">
                            <sweetalert-icon :icon="addTransactionState"/>
                        </v-row>
                        <template v-if="addTransactionState === 'success'">
                            <v-row no-gutters class="standard-row font-theme d-flex justify-center animate-show-card">
                                <span style="font-size: calc(100% + 0.84vw);">บันทึกสำเร็จ</span>
                            </v-row>
                            <v-row v-if="action != 'WaitQT'" no-gutters class="standard-row font-theme d-flex justify-center animate-show-card" style="margin: 20.325px 0px;">
                                <span style="font-size: calc(100% + 0.4vw);">เลขเอกสาร : {{ responseData.data.document_id }}</span>
                            </v-row>
                        </template>
                        <template v-else-if="addTransactionState === 'loading'">
                            <v-row no-gutters class="standard-row font-theme d-flex justify-center">
                                <span style="font-size: calc(100% + 0.84vw);">กำลังดำเนินการ . . .</span>
                            </v-row>
                        </template>
                        <template v-else>
                            <v-row no-gutters class="standard-row font-theme d-flex justify-center animate-show-card">
                                <v-row class="standard-row font-theme d-flex justify-center">
                                    <span v-if="errorMessage === 'fileEmpty'" style="font-size: calc(100% + 0.84vw);" class="text-center">บันทึกไม่สำเร็จ กรุณาแนบไฟล์เพิ่มเติม</span>
                                    <span v-else-if="errorMessage === 'qtVendorDup'" style="font-size: calc(100% + 0.84vw);" class="text-center">บันทึกไม่สำเร็จ Qt Vendor ซ้ำในระบบ</span>
                                    <span v-else style="font-size: calc(100% + 0.84vw);" class="text-center">บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง</span>
                                </v-row>
                                <!-- <v-row v-if="error === 'งบไม่ประมาณคงเหลือไม่เพียงพอ'" class="standard-row font-theme d-flex justify-center">
                                    <span style="font-size: calc(100% + 0.5vw);" class="text-center pt-3">. . . กลับไปหน้ากรอกข้อมูลภายใน {{ countTimeForCloseModal }} วินาที</span>
                                </v-row> -->
                            </v-row>
                        </template>
                    </template>
                </v-card>
            </v-row>

            <v-row class="standard-row text-center d-flex justify-center create-document-row" v-if="addTransactionState === 'success'">
                <div class="mr-3" style="padding-top: 10px;">
                    <v-btn v-if="this.action === 'SaveCsToPo'" @click="saveBudgetModal()" color="#0B68D6"
                        class="elevation-0 font-theme confirm-btn white--text mr-2" style="width: 143px; height: 30px;">
                        บันทึกงบประมาณ
                    </v-btn>
                    <v-btn v-if="this.action === 'SaveCsToPo'" @click="closeDialog()" color="#E0E0E0"
                        class="elevation-0 font-theme confirm-btn white--text ml-2" style="width: 143px; height: 30px;">
                        ไม่บันทึกงบประมาณ
                    </v-btn>
                    <v-btn v-if="this.action === 'RunPo'" @click="saveBudgetModal()" color="#0B68D6"
                        class="elevation-0 font-theme confirm-btn white--text" style="width: 143px; height: 30px;">
                        บันทึกงบประมาณ
                    </v-btn>
                </div>
            </v-row>
            <v-row v-else class="standard-row mt-5"></v-row>
        </v-card>
        <saveBudgetModal />
    </v-dialog>
</template>

<script>
import { MainFunction } from '@/functions/mainFunction.js'
import { EventBus } from '../EventBus'
import saveBudgetModal from '../components/saveBudgetModal.vue'
export default {
    components: {
        saveBudgetModal
    },
    data() {
        return {
            windowSize: { x: 0 },
            dialog: false,
            totalActual: null,
            selectedItemsConfirm: [],
            responseData: [],
            csTransaction: [],
            action: '',
            errorMessage:'',
            headers: [
                { text: 'No', value: 'number' },
                { text: 'Sale Document', value: 'sale_document' },
                { text: 'Document ID', value: 'document_id' },
                { text: 'Group Service', value: 'group_service' },
                { text: 'Actual', value: 'actual' },
                { text: 'Revenue', value: 'revenue' },
            ],
            addTransactionState: 'loading',
            requestBody: []
        };
    },
    mounted() {
        this.onResize()
    },
    computed:{
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz
        },
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        open(action, selectedItemsConfirm, requestBody, totalActual,totalQtValue) {
            this.selectedItemsConfirm = selectedItemsConfirm;
            this.action = action;
            this.addTransactionState = 'loading'
            this.requestBody = requestBody
            this.totalActual = totalActual
            this.totalQtValue = totalQtValue
            this.dialog = true;
            this.addSaveCSPO()
        },
        async addSaveCSPO(){
            try {
                var url = ''
                if(this.action == 'SaveCsToPo'){
                    url = 'add_save_cs_to_po'
                } else if(this.action == 'WaitQT'){
                    url = 'waiting_qt'
                } else if(this.action == 'RunPo'){
                    url = 'add_run_po'
                }
                const { data } = await this.axios.post(`${this.$api_url}/cs_to_po/api/v1/${url}`, this.requestBody)
                if (data.status) {
                    this.responseData = data;
                    this.addTransactionState = 'success'
                    if(this.action != 'WaitQT'){
                        this.transactionId = data.data._id
                    }
                    else if(this.action == 'WaitQT'){
                        setTimeout(this.navigateToWaitQT, 2000)
                    }
                }else if (data.message === "attach file is empty") {
                    this.addTransactionState = 'error'
                    this.errorMessage = 'fileEmpty'
                }else if (data.message === "qt vendor is duplicated") {
                    this.addTransactionState = 'error'
                    this.errorMessage = 'qtVendorDup'
                }else{
                    this.addTransactionState = 'error'
                }
            } catch (error) {
                this.responseData = error
                console.log(error);
                this.addTransactionState = 'error'
            }
        },
        navigateToWaitQT() {
            // Navigate to the '/create_wait_qt' path
            this.$router.push({ path: '/create_cspo_wait_qt' });
        },
        closeDialog() {
            // ทำสิ่งที่คุณต้องการเมื่อ Confirm Dialog ถูกปิด
            // console.log('Confirm Dialog closed!');
            EventBus.$emit('afterOpenSaveBudgetListModal');
            this.dialog = false;
            // อาจจะเรียก method หรือทำอื่นๆ ที่คุณต้องการ
        },
        getTitle() {
            if (this.action === 'SaveCsToPo') {
                return 'บันทึกข้อมูล';
            } else if (this.action === 'RunPo') {
                return 'RUN PO';
            } else {
                return 'Wait QT';
            }
        },
        saveBudgetModal() {
            let tempTypeBudget = []
            this.selectedItemsConfirm?.forEach(e => {
                // if ((e.cut_budget_type?.trim() === 'ต้นทุนขาย (COGS)' && this.inboxPermission?.toLowerCase() === 'cost') || (e.cut_budget_type?.trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' && this.inboxPermission?.toLowerCase() === 'sga') || (e.cut_budget_type?.trim() === 'ต้นทุนวิจัยและพัฒนา (R&D)' && this.inboxPermission?.toLowerCase() === 'rd')) {
                    const tempData = {
                        "item_id"             : "",
                        "item_name"           : e.service_name || null,
                        "cut_budget_type"     : 'ต้นทุนขาย (COGS)',
                        "total_product_price" : e.qt_value || null,
                        "discount"            : e.discount || "0",
                        "currency_exchange"   : e.currency_exchange   || "1",
                        "_id"                 : e._id
                    }
                    tempTypeBudget.push(tempData)
                // }
            })
            const tempSaveBudget = {
                "products"                   : tempTypeBudget,
                "transaction_id"             : this.transactionId                                                                                                       || null,
                "type_budget"                : 'COST'                                                                                                                   || null,
                "tax_id"                     : this.selectedBiz?.tax_id                                                                                                 || null,
                "end_date"                   : this.selectedItemsConfirm[0]?.p_so_05                                                                                   || null,
                "start_date"                 : this.selectedItemsConfirm[0]?.p_so_04                                                                                 || null,
                "total_price"                : this.totalQtValue                                                                                                       || null,
                "document_status"            : 'W'                                                                                                                      || null,
                "in_budget"                  : false,
                "document_status_permission" : 'W'                                                                                                                      || null,
                "save_budget_id"             :  null,
                "from": this.action === 'SaveCsToPo' ? 'save_cs_to_po' : 'run_po'
            }
            EventBus.$emit('openSaveBudgetModal', tempSaveBudget)
            this.dialog = false
        },
        outsideToCloseModal() {
            if (
                this.addTransactionState === 'error' &&
                ["/create_cs_po", "/create_cspo_wait_qt"].includes(
                    window.location.pathname
                )
            ) {
                EventBus.$emit("afterSaveBudget");
            }
            },
    },
}
</script>
<style>
    .scroll-create-purchase-modal {
        max-height: calc(100vh - 254px);
        min-height: 254px !important;
        overflow-y: auto;
        border-radius: 20px !important;
    }
</style>